import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import "../common/CompactHeader.css";

// Add route paths here to opt in to the compact header
const COMPACT_HEADER_ROUTES = ["/delegate/chat"];

interface DelegateUserLayoutProps {
  children: React.ReactNode;
}
const DelegateUserLayout: React.FC<DelegateUserLayoutProps> = (props) => {
  const location = useLocation();
  const useCompactHeader = COMPACT_HEADER_ROUTES.some((route) =>
    location.pathname.startsWith(route),
  );

  return (
    <div
      className={useCompactHeader ? "compact-header" : ""}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100vh",
      }}
    >
      <Header />
      {props.children}
    </div>
  );
};

export default DelegateUserLayout;
